// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c97195f","389":"fd44f4c7","732":"01f60bc9","977":"336cff11"}[chunkId] + ".chunk.js";
};